import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";

export default function InspectionLocation({ data, title }) {
    const [gridApi, setGridApi] = useState(null);
    const inspec = data?.garrison?.fixedInspectionLocation ?? [];

    const inspecMap = {
        NOTHING_NEW: "Regular",
        DAMAGED: "Danificado",
        MISSING: "Ausente",
        IRREGULAR: "Irregular",
    }

    const columnDefs = useMemo(() => ([
        { headerName: "Nome", field: "item", flex: 1 },
        {
            headerName: "Situação",
            field: "answer",
            flex: 1,
            valueFormatter: ({ value }) => inspecMap[value] ?? "",
        },
    ]), []);

    return (
        <div className="px-5 space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={inspec}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: true }}
                    animateRows={false}
                    suppressCellFocus={true}
                    suppressRowHoverHighlight={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    formatters={{
                        answer: (row) => inspecMap[row.answer] ?? row.answer ?? "-"
                    }}
                    gridApi={gridApi}
                    className="!border-0 w-full -mx-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}